module.exports = __webpack_public_path__ + "static/media/waterfront.007283bc.svg";